import { Route, Routes } from "react-router-dom";

import HomePage from './pages/home/homePage.mjs';
import Login from './pages/login/loginPage.mjs';
import UserFiles from './pages/userfiles/userFilesPage.mjs';
import NotFoundPage from './pages/notfound/notFoundPage.mjs';
import ProtectedRoutes from './components/protectedRoutes.mjs';
import ContactPage from './pages/contact/contactPage.mjs';
import ManageClassesPage from './pages/classes/manageClassesPage.mjs';
import WatchLivestreamPage from './pages/watchLivestream/watchLivestreamPage.mjs';
import CreateAccountPage from "./pages/login/createAccountPage.mjs";
import ForgotPasswordPage from "./pages/login/forgotPasswordPage.mjs";
import AdditionalLivestreams from "./pages/watchLivestream/additionalLivestreams.mjs";
import CreateAvatarPage from "./pages/avatar/createAvatar.mjs";

import './app.scss';


const App = () => {
	return (
		<Routes>
			<Route path="/" element={<Login />} />
			<Route path="/create-account" element={<CreateAccountPage />} />
			<Route path="/forgot-password" element={<ForgotPasswordPage />} />
			<Route element={<ProtectedRoutes />}>
				<Route path="/dashboard" element={<HomePage />} />
				<Route path="/manage-classes" element={<ManageClassesPage />} />
				<Route path="/user-files" element={<UserFiles />} />
				<Route path="/contact" element={<ContactPage />} />
				<Route path="/watchLivestream" element={<WatchLivestreamPage/>} />
				<Route path="/add-livestreams" element={<AdditionalLivestreams />} />
				<Route path="/create-avatar" element={<CreateAvatarPage />} />
			</Route>
			<Route path="*" element={<NotFoundPage />} />
		</Routes>
	);
}
export default App;